import styled from 'styled-components'

export const TabContent = styled.div`
  margin-top: var(--space-600);
`
